import { IUpdateAccountPreferencesRequest } from "../entities-generated/models/presenter-account/update-account-preferences-request";
import { ApiClient } from "./api-client";

class PresenterAccountApiClientClass {
  public updateAccountPreferences(request: IUpdateAccountPreferencesRequest) {
    return ApiClient.patch<void>(`presenter-account/preferences`, request);
  }
}

export const PresenterAccountApiClient = new PresenterAccountApiClientClass();